import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useCartStore } from '../../stores';
import { TooltipHelperIcon } from 'src/Pages/EventManagement/components';
import { RouteParamsEvent } from 'src/types/routing';
import { CartItemType } from 'src/types/ui';

import { Flex } from '@chakra-ui/react';
import { OwnersSectionInput } from './OwnersSectionInput';

export const OwnersSection = ({ buyerInfo }: any) => {
  const { eventID } = useParams<RouteParamsEvent>();
  const { getEventCart } = useCartStore();

  const fields = useMemo(
    () =>
      getEventCart(eventID!).reduce<CartItemType[]>((acc, cartItem) => {
        if (cartItem.quantity > 0) {
          const newAcc = [...acc];
          for (let index = 0; index < cartItem.quantity; index++) {
            newAcc.push(cartItem);
          }
          return newAcc;
        } else {
          return acc;
        }
      }, []),
    [eventID, getEventCart],
  );

  return (
    <>
      <Flex as="h2">
        {fields.length === 1
          ? 'Nome do Participante '
          : 'Nome dos Participantes '}
        <TooltipHelperIcon
          label="Será necessária a apresentação de documento de identidade na entrada do evento junto a cada ingresso. Preencha corretamente o nome completo de cada participante. O ingresso pode ser mostrado direto na tela do celular na portaria do evento. Não repita o mesmo nome em diferentes tipos de ingresso."
          ml={1}
        />
      </Flex>
      {fields.map((field, index) => {
        return (
          <OwnersSectionInput
            field={field}
            amountOfItemsInCart={fields.length}
            index={index}
            key={index}
            buyerInfo={buyerInfo}
          />
        );
      })}
    </>
  );
};
